import React, { useState, useEffect } from 'react';
import { Tooltip, } from 'antd';
import './StationSideBarItem.css';

export const StationSideBarItem = ({ children, collapsed, icon, hasPadding, style, hasTooltip, tooltipText, tooltipWidth, displayCollapsed, ...other}) => {

    const [collapse, setCollapse] = useState(collapsed);

    useEffect(() => {
        setCollapse(collapsed);
    }, [collapsed]);

    const addPadding = (hasPadding && !collapsed ? {...style} : {});
    
    const tooltipOverlayInnerStyle = {
        minWidth: tooltipWidth, 
        borderRadius: 5, 
    };

    const collapsedItem = ( 
        hasTooltip ? 
            <Tooltip
                color='var(--tooltip-bg)'
                placement="right" 
                title={<div style={hasPadding ? {padding: '16px', paddingBottom: 0} : {padding: 8}}>{tooltipText || children}</div>}
                classNames={{
                    root: 'sidebar__item__tooltip__overlay'
                }}
                styles={{
                        body: tooltipOverlayInnerStyle
                    }}
                >
                <div className="sidebar__icon--collapsed-icon">{icon}</div>
            </Tooltip> 
        :
            <div className="sidebar__icon--collapsed-icon">{icon}</div> 
        );

    return(
        <>
            <div 
                {...other}
                className={`${other.className || ''} station__sidebar__item ${collapse ? 'station__sidebar__item--collapsed' : 'station__sidebar__item--expanded'}`}
                style={addPadding}
                >
                <span style={{display: collapse && displayCollapsed ? 'block' : 'none'}}>{collapsedItem}</span>
                <span style={{display: !collapse ? 'block' : 'none'}}>{children}</span>
            </div>
        </>
    );
}

StationSideBarItem.defaultProps = {
    hasPadding: true,
    hasTooltip: true,
    tooltipText: false,
    tooltipWidth: '100%',
    children: '',
    displayCollapsed: true,
}
